import React from 'react';
import './Spiner.css';  // Asegúrate de importar el archivo CSS donde definirás los estilos del spinner.
import { useLogo } from '../../LogoContext';

export default function Spiner() {
    const { logo } = useLogo();
    return (
        <div className='spinnerContainer'>
            <div className='spinner'>
                <img src={logo} alt="Spinner" className='spinnerImage' />
                <p>Cargando...</p>
            </div>
        </div>
    );
}
